var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.803 8.6138C26.7778 8.85173 26.7364 9.08679 26.6945 9.32401C25.42 16.5523 18.4473 23.9185 8.38526 22.1443L8.38602 22.14C5.4129 21.6202 2.65242 20.2556 0.433242 18.209C0.856279 18.3372 1.28607 18.4398 1.72133 18.5177C4.18419 18.9542 6.72276 18.5496 8.929 17.3694C6.59599 16.9122 4.81241 15.024 4.4882 12.6694C5.28031 12.9721 6.13096 13.0886 6.97456 13.0106C4.51341 12.045 3.07273 9.47901 3.53189 6.87495C3.53609 6.85112 3.5401 6.82837 3.54412 6.80562C4.22985 7.36325 5.03982 7.74843 5.90614 7.92799C3.78573 5.89775 3.60864 2.56944 5.50099 0.325306C7.67576 4.23259 11.4072 7.03277 15.7674 8.02831C15.6616 6.05061 16.6149 4.16585 18.2716 3.08083C20.8401 1.39821 24.2866 2.11537 25.9694 4.68276C27.2371 4.65722 28.4906 4.41473 29.6774 3.96727C29.0458 5.16154 28.0014 6.08648 26.7392 6.56868C27.846 6.63205 28.9566 6.52855 30.0324 6.26142C29.1039 7.23247 28.0098 8.02801 26.803 8.6138Z",
    fill: "#FAFF29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.00254091a1089c4b10e9a53534da54f4.svg";
export { ForwardRef as ReactComponent };